<template>
  <v-app class="v-responsive__content">
   <router-view></router-view>
    <div class="text-center ma-2" v-if="errorVisible">
      <v-snackbar
        v-model="snackbar"
        :timeout="-1"
        color="red"
        elevation="24"
      >
        Vyskytla se chyba v API requestu {{ errorUrl }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="black"
            text
            v-bind="attrs"
            @click="errorVisible = false"
          >
            X
          </v-btn>
        </template>
      </v-snackbar>
    </div>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  components: {
  },

  data: () => ({
    errorVisible: false,
    snackbar: true,
    errorUrl: ''
  }),
  created () {
    this.$root.$on('api-error', response => {
      this.errorVisible = true
      this.errorUrl = response.config.url
      /* setTimeout(() => {
        this.errorVisible = false
      }, 2500) */
    })
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&family=Readex+Pro:wght@200;300;400;500;600;700&family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
.font-poppins-heading {
  font-family: 'Poppins', sans-serif !important;
}
.font-readex{
  font-family: 'Readex Pro', sans-serif !important;
}
.text-lightGreen{
  color: var(--v-lightGreen-base) !important;
}
.text-darkGreen{
  color: var(--v-darkGreen-base) !important;
}
.lightYellow{
  background-color: var(--v-lightYellow-base);
}
.text-lightYellow{
  color: var(--v-lightYellow-base);
}
.text-white{
  color: white !important;
}
.text-black{
  color: #000 !important;
}
.bg-white{
  background-color: white;
}
.btn {
  cursor: pointer !important;
  border: none !important;
  background-size: 300% 100% !important;
  moz-transition: all .4s ease-in-out !important;
  -o-transition: all .4s ease-in-out !important;
  -webkit-transition: all .4s ease-in-out !important;
  transition: all .4s ease-in-out !important;
}
.btn:hover {
  background-position: 100% 0;
  moz-transition: all .4s ease-in-out;
  -o-transition: all .4s ease-in-out;
  -webkit-transition: all .4s ease-in-out;
  transition: all .4s ease-in-out;
  transition-property: background-color;
}
.btn-green-gradient{
  background-image: linear-gradient(to right, #4ebe4c, #21b873, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(49, 196, 190, 0.75);
  color: white !important;
}
.btn-red-gradient{
  background-image: linear-gradient(to right, #e43603, #fcc722, #fa7199, #e85a19);
  box-shadow: 0 4px 15px 0 rgba(229, 66, 10, 0.75);
  color: white !important;
}
.btn-red-gradient.outlined{
  background-image: none;
  background-color: inherit !important;
  border: 1px solid #e43603 !important;
  color: #e43603 !important;
}
.btn-red-gradient.outlined:hover{
  background-image: linear-gradient(to right, #e43603, #fcc722, #fa7199, #e85a19);
  color: white !important;
}
.v-application .info{
  border-color: var(--v-lightGreen-base) !important;
}
.stripedDT tr:nth-child(even){
  background-color: #e8f2d5 ;
}
.stripedDT th{
  font-weight: 900 !important;
  color: black !important;
}
.stripedDT td{
  font-family: 'Readex Pro', sans-serif !important;
  font-weight: 400 !important;
  color: #979797;
}
.stripedDT table{
  border: 1px solid #d5d5d5 !important;
  border-radius: 10px;
}
.stripedDT table .v-data-table, .stripedDT table header, .stripedDT table table{
  background-color: var(--v-lightYellow-base) !important;
  border: none !important;
  border-radius: 0 !important;
}
/* Scrollbar*/
/* width */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--v-lightGreen-base);
  border-radius: 5px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
